/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NotificationCampaign } from './NotificationCampaign';
import {
    NotificationCampaignFromJSON,
    NotificationCampaignFromJSONTyped,
    NotificationCampaignToJSON,
} from './NotificationCampaign';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface NotificationCampaignPagination
 */
export interface NotificationCampaignPagination {
    /**
     * 
     * @type {Array<NotificationCampaign>}
     * @memberof NotificationCampaignPagination
     */
    data?: Array<NotificationCampaign>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof NotificationCampaignPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the NotificationCampaignPagination interface.
 */
export function instanceOfNotificationCampaignPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NotificationCampaignPaginationFromJSON(json: any): NotificationCampaignPagination {
    return NotificationCampaignPaginationFromJSONTyped(json, false);
}

export function NotificationCampaignPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationCampaignPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(NotificationCampaignFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function NotificationCampaignPaginationToJSON(value?: NotificationCampaignPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(NotificationCampaignToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

